import Cookies from 'js-cookie';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';

const {
  loginBegin,
  loginSuccess,
  loginErr,
  logoutBegin,
  logoutSuccess,
  logoutErr,
  updatePasswordDetailsBegin,
  updatePasswordDetails,
  updatePasswordDetailsErr,
  updatePasswordDetailsEmpty,
} = actions;

const login = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/users/login', values);
      if (response.data?.[0]?.code !== 100) {
        dispatch(loginErr(response.data?.[0]?.message));
      } else {
        dispatch(loginErr(null));
        localStorage.setItem('user', JSON.stringify(response.data?.[0]?.data));
        Cookies.set('access_token', response.data?.[0]?.data?.token);
        Cookies.set('logedIn', true);
        dispatch(loginSuccess(response.data?.[0]?.data));
        callback();
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const fbLogin = (callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      Cookies.set('logedIn', true);
      dispatch(loginSuccess(true));
      callback();
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const register = (values) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/register', values);
      if (response.data.errors) {
        dispatch(loginErr('Registration failed!'));
      } else {
        dispatch(loginSuccess(false));
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      Cookies.remove('logedIn');
      Cookies.remove('access_token');
      dispatch(logoutSuccess(false));
      callback();
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

const updatePassword = (params) => {
  return async (dispatch) => {
    try {
      if (params) {
        const reqData = {
          email: params?.email,
          oldpassword: params?.oldpassword,
          newpassword: params?.newpassword,
        };
        dispatch(updatePasswordDetailsBegin());
        const response = await DataService.post('/users/updatePassword', reqData);
        if (response.data?.[0]?.code !== 100) {
          dispatch(updatePasswordDetailsErr(response.data?.[0]?.message));
        } else {
          dispatch(updatePasswordDetails(response.data?.[0]?.data));
        }
      } else {
        dispatch(updatePasswordDetailsEmpty());
      }
    } catch (err) {
      dispatch(updatePasswordDetailsErr(err));
    }
  };
};

export { login, logOut, register, fbLogin, updatePassword };
